export default function socialSecurityMask(value, record, context) {
    const numbers = value.replace(/\D/g, '');
    const numbersWithDashes = `${numbers.slice(0, 3)}-${numbers.slice(3, 5)}-${numbers.slice(5)}`;

    if (context === 'input-focus') {
        return numbersWithDashes.length === 11 ? numbersWithDashes : value;
    }
    return value.slice(0, -4).replace(/\d/g, '*') + value.slice(-4);
}
